module.exports = __webpack_public_path__ + "img/bate-logo-icon.c2cad197.png";